import { faBell, faMagnifyingGlass, Icon } from '@oppy/omniv2-ui';

import avatarBlank from '@/assets/avatar-blank.png';

export default function Header() {
  return (
    <header className="mb-5 flex h-16 flex-initial items-center rounded-b-lg bg-white p-5 shadow-md">
      <div className="flex-1">
        <Icon icon={faMagnifyingGlass} />
      </div>

      <div className="flex items-center gap-4">
        <Icon icon={faBell} />
        <img src={avatarBlank} alt="avatar" className="size-10" />
      </div>
    </header>
  );
}
